<template>
    <div>
    	<gofix-card title=" " class="gofixCard--partsReplacement" classHeader="mb-0" classContent="mb-18">
            <template slot="gofixCard:right_header">
                <span class="cursor-pointer" @click="editEquipment">
                    <img src="img/iconPencil.png" alt  width="18" height="18"/>
                </span>
            </template>
            <b-row no-gutters>
                <b-col md="12">
                    <div class="d-flex flex-wrap content--equipment">
                        <gofix-text-field label="Lift Number" oneline>{{ equipment.lift_number ? equipment.lift_number : '' }}</gofix-text-field>
                        <gofix-text-field label="Constituency" oneline>{{ equipment.constituency ? equipment.constituency : '' }}</gofix-text-field>
                        <gofix-text-field label="Block" oneline>{{ equipment.blk_number ? equipment.blk_number : '' }}</gofix-text-field>
                        <gofix-text-field label="Postal Code" oneline>{{ equipment.postal_code ? equipment.postal_code : '' }}</gofix-text-field>
                        <gofix-text-field label="Lift Company" oneline>{{ equipment.lift_company ? equipment.lift_company : '' }}</gofix-text-field>
                    </div>
                </b-col>
            </b-row>

            <b-modal 
                :no-close-on-backdrop="true" 
                id="modal-Create"
                title="Equipment Detail" 
                hide-footer 
                :centered="true" 
                v-model="modal.open">

                <b-row>
                    <b-col md="12">
                        <gofix-form-input 
                            label="Equipment Tag"
                             v-model="modal.equipment.tag_name">
                        </gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input
                            :disabled="true"
                            label="Lift Number"
                            v-model="modal.equipment.lift_number">
                        </gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input 
                            :disabled="equipment.constituency === false"
                            label="Constituency" 
                            v-model="modal.equipment.constituency">
                        </gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input 
                            :disabled="equipment.blk_number === false"
                            label="Block" 
                            v-model="modal.equipment.blk_number">
                        </gofix-form-input>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-input 
                            :disabled="equipment.postal_code === false"
                            label="Postal Code" 
                            v-model="modal.equipment.postal_code">
                        </gofix-form-input>
                    </b-col>
                </b-row>

                <b-button-group class="d-block text-right pr-4">
                    <gofix-button label="APPLY" @click="saveEquipment" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>

            </b-modal>
        </gofix-card>
        <parts-replacement name-table="part-replacement-history-equipment-listing" value-title="Parts Replacement Records" :is_in_contract="true" @row-click="rowClick"></parts-replacement>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const partsReplacement = () => import("../parts-replacement/list.vue")
    import moment from 'moment';

    export default {
        name: 'parts-replacement-history',
        components: {
        	partsReplacement
        },
        data() {
            return {
                modal: {
                    open: false,
                    loading: false,
                    timer: null,
                    equipment: {
                        tag_name: null,
                        constituency: null,
                        blk_number: null,
                        postal_code: null,
                        street_name: null,
                        lift_company: null
                    }
                },
                custom_fields: [],
                equipment: {
                    tag_name: null,
                    tc_code: false,
                    address_prefix: false,
                    lift_number: false,
                    constituency: false,
                    blk_number: false,
                    postal_code: false,
                    street_name: false,
                    lift_company: false
                }
            }
        },
        created() {
            this.setEquipment(this.detaiEquipment)
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                detaiEquipment: "EquipmentV2Controller/equipment",
            }),
        },
        watch: {
            detaiEquipment: function(val) {
                this.setEquipment(val)
            }
        },
        methods: {
            setEquipment(val) {
                if(val) {
                    let location = val.location_info ? val.location_info.name:'';
                    this.equipment.tag_name = val.tag_name;
                    let tableData = JSON.parse(JSON.stringify(val));
                    for (let i = 0; i < tableData.length; i++) {
                        if (tableData[i].attribute.type === "DateTime" && tableData[i].value) {
                            tableData[i].value = new Date(tableData[i].value);
                        }
                    }
                    this.custom_fields = tableData.custom_fields;
                    if(val.custom_fields) {
                        let custom_fields = val.custom_fields;
                        custom_fields.map(item => {
                            let key = item.attribute.name ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';
                            if(key == 'block_no' || key == 'block_number') key = 'blk_number';
                            if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                            if(this.equipment.hasOwnProperty(key)) {
                                let value = item.value;
                                if(value && item.attribute.type === "DateTime") {
                                    value = moment(value).format("DD.MM.YYYY");
                                }
                                if(value){
                                    this.equipment[key] = value;
                                }
                            }
                        })
                    }
                    //this.part_replacement.blk_address = location;
                    /*if(this.equipment.tc_code) {
                        this.part_replacement.lift_code = `${this.equipment.tc_code}-`;
                    }

                    if(this.equipment.address_prefix) {
                        this.equipment.lift_code += `${this.equipment.address_prefix}-`;
                    }

                    if(this.equipment.blk_number) {
                        this.equipment.lift_code += `${this.equipment.blk_number}-`;
                    }

                    if(this.equipment.lift_number) {
                        this.equipment.lift_code += this.equipment.lift_number;
                    }*/
                }
            },
            saveEquipment() {
               if (this.modal.timer) {
                    clearTimeout(this.modal.timer);
                    this.modal.timer = null;
                }
                this.modal.timer = setTimeout(async () => {
                    this.modal.loading = true;
                    var data = [];
                    for(let i = 0; i < this.custom_fields.length; i++){
                        let item = Object.assign({},this.custom_fields[i]);
                        let key = item.attribute ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';

                        if(key == 'block_no' || key == 'block_number') key = 'blk_number';
                        if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                        if(key == 'address_prefix' || key == 'prefix') key = 'address_prefix';
                        
                        if(['Constituency', 'Block Number', 'Block No', 'Postal Code', 'Lift No', 'Lift Number'].includes(item.attribute.name) && this.equipment.hasOwnProperty(key)) {
                            item.value = this.modal.equipment[key];
                            if(item.type === "DateTime" && item.value){
                                item.value =  moment(item.value).format('YYYY-MM-DD');
                            }
                        }
                        data.push(item);
                    }
                    let objClone = JSON.parse(JSON.stringify(this.detaiEquipment));
                    objClone.tag_name = this.modal.equipment.tag_name;
                    objClone.custom_fields = data;

                    this.$store.dispatch('EquipmentV2Controller/saveEquipment', objClone)
                    .then(async result => {
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.getEquipment();
                        this.$alertNotification(this.$notificationV2('editing', 'equipment'));
                    })
                    .catch(err => {
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.$alertNotification(err.response.data.error.message.error, "danger");
                    })
                }, 100);
            },
            editEquipment() {
                this.modal.equipment.lift_number = this.equipment.lift_number !== false ? this.equipment.lift_number : null;
                this.modal.equipment.street_name = this.equipment.street_name !== false ? this.equipment.street_name : null;
                this.modal.equipment.lift_company = this.equipment.lift_company !== false ? this.equipment.lift_company : null;
                this.modal.equipment.tag_name = this.equipment.tag_name !== false ? this.equipment.tag_name : null;
                this.modal.equipment.constituency = this.equipment.constituency !== false ? this.equipment.constituency : null;
                this.modal.equipment.blk_number = this.equipment.blk_number !== false ? this.equipment.blk_number : null;
                this.modal.equipment.postal_code = this.equipment.postal_code !== false ? this.equipment.postal_code : null;
                this.modal.open = true;
            },
            getEquipment() {
                this.$store.dispatch('EquipmentV2Controller/getEquipment', this.$route.params.equipment_id).then(response => {}).catch(error => {})
            },
            rowClick(item) {
                return this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment/${this.$route.params.equipment_id}/part-replacement/${item.row_id}`)
            }
        }
    }
</script>
